import styled from "styled-components";

// A real heading element that looks like whatever wraps it. Page titles on this site are styled
// containers (BlockTitle and friends) that often hold buttons as well, so the heading wraps only
// the text and inherits the container's typography. Defaults to h1; pass `as="h2"` for sections.
const PageHeading = styled.h1`
  margin: 0;
  font: inherit;
  color: inherit;
`;

// For pages whose visible design has no title line (the home page, the videos hub). The heading
// still exists for search engines and screen readers, and its text must match what the page shows.
export const VisuallyHiddenHeading = styled.h1`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

export default PageHeading;
